import api from "@/api/global-work-histories";

export default {
  state: {},
  mutations: {},
  actions: {
    async retrieveGlobalWorkHistories(context, { id, management_id } ) {
      try {
        let mid = management_id;
        if (mid == null) {
          mid = await context.dispatch("showManagementID");
        }
        const res = await api.index(mid, id);
        return res.data;
      } catch (error) {
        throw error;
      }
    },

    async insertGlobalWorkHistory(context, { season, item, workItems, imagePaths, workHistoryId }) {
      try {
        await api.create(
          await context.dispatch("showManagementID"),
          season,
          item,
          workItems,
          imagePaths,
          await context.dispatch("showAccountID"),
          await context.dispatch("showUserId"),
          workHistoryId,
        );
      } catch (error) {
        throw error;
      }
    },

    async updateGlobalWorkHistory(context, { workHistory, workItems, imagePaths }) {
      try {
        await api.update(
          await context.dispatch("showManagementID"),
          workHistory,
          workItems,
          imagePaths,
          await context.dispatch("showAccountID"),
          await context.dispatch("showUserId"),
        );
      } catch (error) {
        throw error;
      }
    },

    async deleteGlobalWorkHistory(context, { id }) {
      try {
        const res = await api.del(
          await context.dispatch("showManagementID"),
          id,
          await context.dispatch("showAccountID"),
          await context.dispatch("showUserId"),
        );
        return res.data;
      } catch (error) {
        throw error;
      }
    }
  },
  getters: {}
};
